<div>
  <mat-icon>sms_failed</mat-icon>
  <p uid="error-message-404">The resource you are looking for could not be found.</p>
</div>
